import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PageBase } from 't4core';
import { T4DatatableWidget } from '../../../../../t4common';
import { FormControl } from '@angular/forms';

@Component({
    styleUrls: ['./BluetoothLocks.css'],
    selector: 'BluetoothLocks',
    templateUrl: './BluetoothLocks.component.html',
})
export class BluetoothLocks extends PageBase implements OnInit {

  @ViewChild("lockTable", { static: false }) table: T4DatatableWidget;

  constructor(el: ElementRef, private changeDetectorRef: ChangeDetectorRef) {
        super(el, "BluetoothLocks");
  }

  public rawData: any[];

  public lockData;
  public filteredLockData;
  public actionPendingData;
  public filterGroups = new Set<string>();
  public filterGroupList = [];
  groupsControl = new FormControl([]);

  public async ngOnInit() {

    var token = this.UI.beginLoading("T4.Service.BluetoothLocks.ldrLoadingTrailers", "Loading Trailers with Locks", null);
    

    
    const currentTime = new Date();
    const formattedTime = currentTime.toISOString().replace('T', ' ').slice(0, 19);

    this.rawData = await this.Api.get<any>("DataService/GetReport", { reportName: 'BluetoothLockStatus', from: formattedTime, to: formattedTime });

    this.lockData = this.rawData.filter(x => {
      if (x.ActionExpire === null || x.ActionExpire === undefined)
        return true;

      return x.ActionExpire.toDate() < currentTime;
    });


    this.actionPendingData = this.rawData.filter(x => {
      if (x.ActionExpire === null || x.ActionExpire === undefined)
        return false;


      return x.ActionExpire.toDate() > currentTime;
    });

    await this.createFilterOptions();

    this.UI.loaderCompleted(token);
  }

  public async createFilterOptions() {
    this.lockData.forEach(x => this.filterGroups.add(x.RentalLocationGroupName));
    this.applyFilter();
  }

  applyFilter() {
    const selectedGroups = this.groupsControl.value;
    this.filteredLockData = this.filterData(selectedGroups);
    this.changeDetectorRef.detectChanges();
  }

  filterData(selectedGroups: string[]): any {
    if (selectedGroups.length === 0) return this.lockData
    return this.lockData.filter(item => selectedGroups.some(group => group === item.RentalLocationGroupName));
  }

  public async addAction(x: any) {
    console.log(x);
    var ret = await this.UI.openDialog('T4.Service.AddActionDialog', {
      width: "400px",
      data: x
    }) as { comment: string, date: moment.Moment };

    console.log(ret.date.toDate());

    if (ret) {
      var result = await this.Api.post<boolean>("RentalObject/RegisterLockAction", null, { objectId: x.TrailerId, comment: ret.comment, handledTo: ret.date.toDate().toISOString() })
      if (result)
        this.table.update();
      else
        this.UI.alert("Turbo.BluetoothLock.RegisterAction.ErrorMsg", "Failed!", "Turbo.BluetoothLock.RegisterAction.ErrorMsgAction", "Registering the action failed.");
    }
    
    
  }

}
